import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FileModel} from './filesList/file.model';
import {IFileEvent} from './filesList/interface/IFileEvent';
import {Button} from './toolbar/models/button.model';
import {FilesListComponent} from './filesList/filesList.component';
import {IToolbarEvent} from './toolbar/interface/IToolbarEvent';
import {IFileModel} from './filesList/interface/IFileModel';
import {FileManagerConfiguration} from './configuration/fileManagerConfiguration.service';
import {Store} from '@ngrx/store';
import {FileManagerEffectsService} from './store/fileManagerEffects.service';
import {FileManagerApiService} from './store/fileManagerApi.service';
import {FilemanagerNotifcations, INotification} from './services/FilemanagerNotifcations';
import {CurrentDirectoryFilesService} from './services/currentDirectoryFiles.service';
import {IOuterFile} from './filesList/interface/IOuterFile';
import {FILEMANAGER_TREE_NAME} from './store/fileManagerApiAbstract.class';
import {
  ChooseFilesAction,
  DeleteSelectedFilesAction,
  InverseFilesSelectionAction,
  LoadFilesAction,
  SelectAllFilesAction,
  UnSelectAllFilesAction
} from './store/file-manager.action';
import {BehaviorSubject, combineLatest, Observable, Subscription} from 'rxjs';
import {NodeService} from "../angular2-tree/service/node.service";
import {TreeComponent} from "../angular2-tree/tree.component";
import {ITreeData, ITreeState} from "../angular2-tree/store/ITreeState";
import {IConfiguration} from "../angular2-tree/interfaces/IConfiguration";
import {TreeModel} from "../angular2-tree/models/TreeModel";
import {IContextMenu} from "../angular2-tree/interfaces/IContextMenu";
import {IOuterNode} from "../angular2-tree/interfaces/IOuterNode";
import {NodeDispatcherService} from "../angular2-tree/service/nodesDispatcher.service";
import {TreeInitializerService} from "../angular2-tree/service/initializer.service";
import {MessageService} from "primeng/api";

@Component({
    standalone: false,
  selector: 'ri-filemanager',
  providers: [NodeService, MessageService],
  styleUrls: ['./main.less'],
  templateUrl: './filemanager.html'
})
export class FileManagerComponent implements OnInit, OnDestroy {
  @Output()
  public onSingleFileSelect = new EventEmitter();

  @Input()
  public mode: string = '1';

  @ViewChild(TreeComponent)
  public treeComponent: TreeComponent;

  @ViewChild(FilesListComponent)
  public filesList: FilesListComponent;

  /**
   * List of files for current selected directory
   */
  public files$: Observable<FileModel[]>;

  public filteredFiles$: Observable<FileModel[]>;
  public selectedFiles$: Observable<string[]>;

  public folders: Observable<ITreeData>;

  public treeConfiguration: IConfiguration = {
    showAddButton: false,
    disableMoveNodes: false,
    treeId: FILEMANAGER_TREE_NAME,
    dragZone: FILEMANAGER_TREE_NAME,
    dropZone: [FILEMANAGER_TREE_NAME]
  };

  public treeModel: TreeModel;

  /** UNSED **/
  public contextMenu: IContextMenu[] = [];

  public currentSelectedFile: IFileModel;
  public currentSelectedFilesIds: string[] = [];
  public currentSelectedFiles: IOuterFile[] = [];

  public isPreviewMode = false;

  public mode$ = new BehaviorSubject('0');

  public notificationOptions = {
    position: ['bottom', 'right'],
    timeOut: 3000,
    lastOnBottom: false,
    preventDuplicates: true,
    rtl: false,
    showProgressBar: true,
    pauseOnHover: true
  };

  /**
   * List of context menu
   */
  public menu: IContextMenu[];

  protected currentSelectedFolder: IOuterNode;

  @Output()
  public externalSelect = new EventEmitter();
  @Output()
  public externalFolderSelect = new EventEmitter();

  public subscription = new Subscription();

  @Input("selectOnly")
  public selectOnly: boolean = false;

  public constructor(public store: Store<ITreeState>,
                     public nodeDispatcherService: NodeDispatcherService,
                     public treeService: FileManagerApiService,
                     public notifications: MessageService,
                     public configuration: FileManagerConfiguration,
                     public fileManagerEffects: FileManagerEffectsService,
                     public filemanagerNotifcations: FilemanagerNotifcations,
                     public currentDirectoryFilesService: CurrentDirectoryFilesService,
                     public treeInitializerService: TreeInitializerService) {


    this.filemanagerNotifcations.getNotificationStream()
      .subscribe((notification: INotification) => {
        const {type, title, message} = notification;

        this.notifications[type](title, message);
      });

    this.subscription.add(
      this.currentDirectoryFilesService.selectedFiles$
        .subscribe((data: string[]) => {
          this.currentSelectedFilesIds = data;
        })
    );

    this.subscription.add(
      combineLatest(
        this.currentDirectoryFilesService.selectedFiles$,
        this.currentDirectoryFilesService.entities$,
      )
        .subscribe(([ids, entities]: [string[], { [key: string]: IOuterFile }]) => {
          this.currentSelectedFiles = ids.map((id) => entities[id]);
        })
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public ngOnInit(): void {
    this.mode$.next(this.mode);
    this.treeModel = this.treeInitializerService.init(this.treeConfiguration, this.treeService);

    this.subscription.add(
      this.treeModel.currentSelectedNode$
        .subscribe((node: IOuterNode) => this.currentSelectedFolder = node)
    );

    /*** START - init files ***/
    this.files$ = this.currentDirectoryFilesService.files$;
    this.filteredFiles$ = this.currentDirectoryFilesService.filteredFiles$;
    this.selectedFiles$ = this.currentDirectoryFilesService.selectedFiles$;


    this.subscription.add(
      this.treeModel.currentSelectedNode$
        .subscribe((node: IOuterNode | null) => {
          this.loadFiles(node ? node.id : '');
        })
    );

  }

  get currentSelectedFolderId(): string | null {
    return this.currentSelectedFolder ? this.currentSelectedFolder.id : null;
  }


  public onAddFolder() {
    this.treeComponent.onAdd();
  }

  /***********************************************************************
   * FILE EVENTS
   **********************************************************************/
  /**
   * Run when all files are uploaded
   */
  public onUpload(folderId: string) {
    //this.notifications.success('File upload', 'Upload complete');
  }


  public onPreviewFile(fileEventData: IFileEvent) {
    this.isPreviewMode = true;
    this.currentSelectedFile = fileEventData.file;
  }


  public onSelectFile(event: FileModel) {
    this.onSingleFileSelect.next(event.getSelectData());
  }

  /***********************************************************************
   * TOOLBAR EVENTS
   **********************************************************************/


  public onMenuButtonClick(event: IToolbarEvent) {
    switch (event.name) {
      case Button.CHOOSE_SELECTION:
        this.store.dispatch(new ChooseFilesAction({files: this.currentSelectedFiles}));
        break;
      case Button.DELETE_SELECTION:
        this.store.dispatch(new DeleteSelectedFilesAction({files: this.currentSelectedFilesIds}));
        break;
      case Button.SELECT_ALL:
        this.store.dispatch(new SelectAllFilesAction());
        break;
      case Button.UNSELECT_ALL:
        this.store.dispatch(new UnSelectAllFilesAction());
        break;
      case Button.INVERSE_SELECTION:
        this.store.dispatch(new InverseFilesSelectionAction());
        break;
      case Button.REFRESH_FILES_LIST:
        this.reloadFiles();
        break;
      case Button.DOWNLOAD_AS_ZIP:
        this.treeService.downloadAsZip(this.currentSelectedFolderId || '');
        break;
    }
  }

  onModeChange(event) {
    this.mode$.next(event.value);
  }

  /***********************************************************************
   * OTHER FUNCTIONS
   **********************************************************************/
  @HostListener('window:keydown', ['$event'])
  public keyEvents(event: KeyboardEvent) {
    if (this.isPreviewMode) {
      if (event.keyCode === 27) {
        this.closeModal();
      }
    }
  }

  public closeModal() {
    this.isPreviewMode = false;
  }


  public loadFiles(folderId: string) {
    this.externalFolderSelect.emit(folderId);
    this.store.dispatch(new LoadFilesAction({folderId: folderId || ''}));
  }

  public reloadFiles() {
    const id = this.currentSelectedFolder ? this.currentSelectedFolder.id : '';
    this.loadFiles(id);
  }

  public external(file) {
    this.externalSelect.emit(file);
  }
}
